export const books = [
  {
    id: 'MySistersSecret',
    title: 'My Sister’s Secret',
    coverKey: 'book11',
    isNext: true,
    home: {
      // kicker: 'New Jane Corry Novel',
      // publisherLine: 'Out 10 March 2026',
      highlight: 'New Jane Corry Novel',
      homeBlurb: [
        'A gripping and emotional suspense about two sisters and the dark past that binds them, from the eight-time Sunday Times bestselling author.',
      ],
      regionLinks: [
        {
          label: 'Pre-order',
          url: 'https://amzn.eu/d/01mAcbK3',
          className: 'link2',
        },
      ],

      starQuotes: [
        {
          text: 'Jane Corry writes compelling and deliciously dark stories of murder and secrets',
          author: 'Claire Douglas',
        },
        {text: 'Few writers can match Jane Corry', author: 'Cara Hunter'},
        {
          text: 'Jane Corry is the queen of family mysteries',
          author: 'Claire Douglas',
        },
      ],
    },
  },
  {
    id: 'tsirs',
    title: 'The Stranger in Room Six',
    isLatest: true,
    coverKey: 'book10',
    tagline:
      'You may not know the stranger in room six. But they know everything about you.',
    description: [
      "It's been fifteen years since Belinda was convicted of her husband's murder. Now, she's ready for her life to begin again, and she's set on that happening at Sunnyside Home for the Young at Heart.",
      "The owner, Mabel, has spent her life here. First as an evacuee during the Blitz and now as the care home's oldest resident, Mabel has held the secrets of this house for as long as she can remember. Secrets that could kill if in the wrong hands.",
      "But history won't stay hidden forever and someone is onto them both. Watching and listening from room number six, they'll stop at nothing to find out the truth.",
      'With a past this dark, is anyone as innocent as they seem?',
    ],
    blurbs: [
      'A deliciously dark story of murder and secrets — Claire Douglas',
      'Gripping and clever — Heidi Perks',
      'Clever, satisfying and packing an emotional punch — Andrea Mara',
      'Haunting and compelling — Nicci French',
      "Jane Corry's novels are always so vividly written and skilfully plotted and this latest is no exception — BP Walter",
    ],
    links: [
      {
        label: 'Ebook',
        url: 'https://www.amazon.co.uk/Stranger-Room-Six-page-turning-bestselling-ebook/dp/B0D3G6ZZHR',
      },
      {
        label: 'Paperback',
        url: 'https://www.waterstones.com/book/the-stranger-in-room-six/jane-corry/9781405975292',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/223362295-the-stranger-in-room-six',
      },
    ],
    home: {
      // kicker: 'NEW JANE CORRY NOVEL.',
      publisherLine: 'PUBLISHED BY PENGUIN VIKING.',
      highlight: 'A SUNDAY TIMES BEST-SELLER!',
      homeBlurb: [
        'Mabel was evacuated to Devon during WW2 and later in life, turned it into a nursing home where she is one of the residents. One of her carers is Belinda a mother of two, who, unknown to everyone else, has just been released from prison for murdering her husband. Mabel and Belinda share their stories and secrets. But in doing so, they each risk the other’s safety.',
      ],
      regionTitle: 'The Stranger in Room Six is also out in Canada and the US!',
      regionLinks: [
        {
          label: 'Click here to order online',
          url: 'https://www.amazon.co.uk/Stranger-Room-Six-pageturning-bestselling/dp/1405975296',
          className: 'link1',
        },
        {
          label: 'Click here to order in Canada',
          url: 'https://www.penguinrandomhouse.ca/books/801285/the-stranger-in-room-six-by-jane-corry/9780385702621',
          className: 'link2',
        },
        {
          label: 'Click here to order in the US',
          url: 'https://www.penguinrandomhouse.com/books/801285/the-stranger-in-room-six-by-jane-corry/',
          className: 'link2',
        },
      ],
      starQuotes: [
        {
          text: 'A deliciously dark story of murder and secrets',
          author: 'Clare Douglas',
        },
        {
          text: 'Jane Corry is the Queen of family mysteries',
          author: 'Andrea Mara',
        },
      ],
    },
  },

  {
    id: 'idoat',
    title: 'I Died On A Tuesday',
    coverKey: 'book9',
    description: [
      '18 year old Janie is leaving home for a new life. World-famous rockstar Robbie is harbouring a shocking secret. Witness support officer Vanessa is desperate to right the wrongs of her past. They tried to bury that fateful day. But now it’s back to haunt them.',
      'THERE’S THE STORY EVERYONE BELIEVES . . .',
      '. . . AND THEN THERE’S THE TRUTH.',
    ],

    links: [
      {
        label: 'Ebook',
        url: 'https://www.amazon.co.uk/Died-Tuesday-gripping-thriller-bestselling-ebook/dp/B0CNT62W14',
      },
      {
        label: 'Paperback',
        url: 'https://www.waterstones.com/book/i-died-on-a-tuesday/jane-corry/9780241996126',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/202517912-i-died-on-a-tuesday',
      },
    ],
  },

  {
    id: 'ctfy',
    title: 'Coming to Find You',
    coverKey: 'book8',
    description: [
      "When her family tragedy is splashed across the newspapers, Nancy decides to disappear. Her grandmother's beautiful Regency house in a quiet seaside village seems like the safest place to hide. But the old house has its own secrets and a chilling wartime legacy . . .",
      "Now someone knows the truth about the night Nancy's mother and stepfather were murdered. Someone knows where to find her. And they have nothing to lose . . .",
      'So what really happened that night? And how far will she go to keep it hidden?',
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/Coming-Find-You-heart-wrenching-suspenseful/dp/0241996104',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/451069/coming-to-find-you-by-corry-jane/9780241996102',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/64645772-coming-to-find-you',
      },
    ],
  },

  {
    id: 'wahos',
    title: 'We All Have Our Secrets',
    coverKey: 'book7',
    description: [
      "You know she's lying... But so are you.",
      "Emily made one bad decision, and now her career could be over. Her family home on the Cornish coast is the only place where she feels safe. But when she arrives, there's a stranger living with her father.",
      "Emily doesn't trust the beautiful young woman, convinced that she's telling one lie after another. Soon, Emily becomes obsessed with finding out the truth...",
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/We-All-Have-Our-Secrets-ebook/dp/B09H2Q5SHD',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/317041/we-all-have-our-secrets-by-corry-jane/9780241989029',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/59063637-we-all-have-our-secrets',
      },
    ],
  },

  {
    id: 'tlwt',
    title: 'The Lies We Tell',
    coverKey: 'book6',
    description: [
      'Save your son, or save yourself?',
      "Sarah always thought of herself and her husband, Tom, as good people. But that was before their son Freddy came home saying he'd done something terrible. Begging them not to tell the police.",
      'As the lies build up and Sarah is presented with the perfect opportunity to get Freddy off the hook, she is faced with a terrifying decision.',
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/Lies-We-Tell-Jane-Corry/dp/0241989000',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/317040/the-lies-we-tell-by-corry-jane/9780241989005',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/54139124-the-lies-we-tell',
      },
    ],
  },

  {
    id: 'imam',
    title: 'I Made a Mistake',
    coverKey: 'book5',
    description: [
      'It started with a kiss and ended with murder.',
      "In Poppy Page's mind, there are two types of women in this world: those who are faithful to their husbands, and those who are not.",
      'Poppy makes a single mistake - and that mistake will be far more dangerous than she could imagine.',
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/I-Made-Mistake-Jane-Corry/dp/0241984653',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/309670/i-made-a-mistake-by-corry-jane/9780241984659',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/52706064-i-made-a-mistake',
      },
    ],
  },

  {
    id: 'ila',
    title: 'I Looked Away',
    coverKey: 'book4',
    description: [
      'Every Monday, 49-year-old Ellie looks after her grandson Josh. She loves him more than anyone else in the world.',
      'And just for a moment, Ellie takes her eyes off her grandson. What happens next will change her life forever.',
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/Looked-Away-page-turning-Sunday-bestseller/dp/0241984637',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/309669/i-looked-away-by-corry-jane/9780241984635',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/40667415-i-looked-away',
      },
    ],
  },

  {
    id: 'tde',
    title: 'The Dead Ex',
    coverKey: 'book3',
    description: [
      "Vicki's husband David once promised to love her in sickness and in health. But after a brutal attack left her suffering with epilepsy, he ran away with his mistress.",
      "What really happened on the night of David's disappearance? And how can Vicki prove her innocence, when she's not even sure of it herself?",
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/Dead-Ex-unputdownable-bestselling-thriller/dp/0241981743',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/305994/the-dead-ex-by-corry-jane/9780241981740',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/40391960-the-dead-ex',
      },
    ],
  },

  {
    id: 'tkt',
    title: 'The Killing Type',
    coverKey: 'book2',
    description: [
      'Susie and her sister have never been close. These days they barely speak. So when Danielle messages her out of the blue and begs to meet, Susie knows something must be wrong.',
      'Who is lying? Who is telling the truth? And who, really, is the killing type?',
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/Killing-Type-bestselling-author-Husbands-ebook/dp/B079XX8CRR',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/309860/the-killing-type-by-corry-jane/9780241984581',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/38719858-the-killing-type',
      },
    ],
  },

  {
    id: 'bs',
    title: 'Blood Sisters',
    coverKey: 'book1',
    description: [
      "Kitty lives in a care home. She can't speak properly, and she has no memory of the accident that put her here. At least that's the story she's sticking to.",
      'But someone is watching Kitty and Alison. Someone who wants revenge for what happened that sunny morning in May. And only another life will do . . .',
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/Blood-Sisters-Jane-Corry/dp/0525522182',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/294513/blood-sisters-by-corry-jane/9780241976722',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/35580277-blood-sisters',
      },
    ],
  },

  {
    id: 'mhw',
    title: "My Husband's Wife",
    coverKey: 'book0',
    description: [
      'What if your life was built on a lie?',
      "When lawyer Lily marries Ed, she's determined to make a fresh start. To leave the secrets of the past behind.",
      'First comes love, then comes marriage, then comes murder . . .',
    ],
    links: [
      {
        label: 'Amazon',
        url: 'https://www.amazon.co.uk/My-Husbands-Wife-Jane-Corry/dp/0241256488',
      },
      {
        label: 'Penguin',
        url: 'https://www.penguin.co.uk/books/294457/my-husbands-wife-by-corry-jane/9780241256480',
      },
      {
        label: 'Goodreads',
        url: 'https://www.goodreads.com/book/show/31227076-my-husband-s-wife',
      },
    ],
  },
];
